module.exports = __webpack_public_path__ + "static/img/counter_01.50fc784.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2022/corona/counter_01.png
// module id = o6XO
// module chunks = 0